import { createWebHistory, createRouter } from 'vue-router';
import store from "../store";

import GuestLayout from '../layouts/GuestLayout'
import LandingPage from '../pages/LandingPage/LandingPage'
import MaintenancePageLayout from '../layouts/Maintenance.vue'
import ItemShopPage from '@/components/user-panel/contents/item-shop/ItemShopPage.vue';

const routes = [
	{
    path: '/',
    name: 'Home',
    component: GuestLayout,
    children: [
      {
        path: '/',
        name: 'Dashboard',
        component: LandingPage
      }
    ]
  },
  {
    path: '/user',
    name: 'user',
    redirect: '/user/panel',
    component: GuestLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/user/panel',
        name: 'panel',
        component: LandingPage
      }
    ]
  },
  {
    path: '/',
    name: 'TopupShop',
    component: GuestLayout,
    children: [
      {
        path: '/topup',
        name: 'Shop',
        component: ItemShopPage
      }
    ]
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: MaintenancePageLayout
  }
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

const state = store.state

router.beforeEach(async (to, from, next) => {
  if (to.query.topup && to.query.ref && to.query.session_id) {
    // validation need to check
    localStorage.setItem('topup', to.query.topup)
    localStorage.setItem('ref', to.query.ref)
    localStorage.setItem('session_id', to.query.session_id)
    localStorage.setItem('checked', 'not')
  }

  if (to.path === '/') {
    if (localStorage.getItem('authToken')) {
      next({name: 'user'})
    }
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (state.isLoggedIn || localStorage.getItem('authToken')) {
      await store.dispatch('user/getAuthUser')
        .then(() => {
          next()
        })
        .catch(() => {
          store.dispatch('user/clearData')
          localStorage.clear()
          next('/')
        })
    }
  }
  next()
});

export default router;